import { useContext } from "react";
import { RealTimeContext } from "../context/RealTimeContext.js";
const useRealTimeContext = ()=>{
    const context = useContext(RealTimeContext);
    if (!context) throw new Error('useRealTimeContext must be used within a RealTimeProvider');
    return context;
};
export { useRealTimeContext };
